import React from 'react';

import {GenericNewElementPage} from 'app/components/general/GenericNewElementPage';
import {useCreatePolicy} from 'app/policies/api';

export const NewPolicyPage = () => {
  const [createPolicy] = useCreatePolicy();

  return (
    <GenericNewElementPage
      elementName={'policy'}
      createNewDocument={(args) => createPolicy(args).unwrap()}
    />
  );
};
